<template>
  <v-dialog v-model="show">
    <!-- Semi-transparent card -->
    <v-card color="rgb(68, 71, 90, 0.95)" width="800px">
      <v-container>

        <!-- Text -->
        <v-row>
          <v-col ref="predictionText">
            <h2>Predictions:</h2>
            <p>{{ scoreText }}</p>
          </v-col>
        </v-row>

        <!-- Buttons -->
        <v-row dense>
          <v-col cols="6">
            <v-btn @click="emit('update:modelValue', false)" color="#ff5555" block>Close</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="cyan-lighten-4" block @click="downloadResults()">Download results</v-btn>
          </v-col>
        </v-row>

      </v-container>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  score: {
    type: Object,
    default: () => {}
  }
})
const emit = defineEmits(['update:modelValue'])

const store = useStore()

const show = computed(() => props.modelValue)

function formatScore (rawScore, modelType) {
  if (modelType === 'average') {
    return `${rawScore === 1 ? 'Active' : 'Inactive'}`
  } else if (modelType === 'regression') {
    const molar = 10 ** (-1 * rawScore)
    const microMolar = molar * (10 ** 6)
    return `${microMolar.toFixed(2)} μM`
  }
}

const predictionText = ref(null)
const scoreText = computed(() => {
  const parent = document.getElementById('predictionText')
  let out = ''
  for (const key in props.score) {
    const prediction = props.score[key]
    console.log(prediction)
    // out += `${key}: ${formatScore(prediction.score, prediction.type)}\n`
    out += `\t${key}\n\t\tprediction: ${formatScore(prediction.score, prediction.type)}\n`

    if (prediction.type === 'average') {
      out += `\t\tapplicability domain score: ${parseFloat(prediction.ad_score).toFixed(2)}\n`
    }
  }
  return out
})

function downloadResults () {
  const out = `SMILES: ${store.getters.smiles}\n\nPredictions:\n${'-'.repeat(12)}\n${scoreText.value}`
  const url = window.URL.createObjectURL(new Blob([out]))
  const link = document.createElement('a')
  link.href = url
  link.download = 'ache_predictions.txt'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
</script>

<style scoped>
h2 {
  color: #f8f8f2;
  font-size: 26pt;
}
p {
  color: #f8f8f2;
  text-align: left;
  white-space: pre;
}
</style>
